import branding from './branding'
import account from './account'
import shared from './shared'
import validation from './validation'
import error from './error'
import forms from './forms'
import enums from './enums'
import nav from './nav'
import load from './load'
import message from './message'
import units from './units'
import map from './map'
import currency from './currency'
import payment from './payment'
import bankAccount from './bank-account'
import session from './session'
import commercialBanking from './commercial-banking'
import wallet from './wallet'
import credential from './credential'

export default {
  direction: 'rtl',
  branding,
  account,
  shared,
  validation,
  error,
  forms,
  enums,
  nav,
  load,
  message,
  units,
  map,
  currency,
  payment,
  bankAccount,
  session,
  commercialBanking,
  wallet,
  credential
}
